import {createSlice} from "@reduxjs/toolkit";
import {stat} from "fs";

export const reducerName = "chat";
export const initialState = {
    chatData: null,
    messagesCount: 0,
    messages: [],
    error: false,
    // fast fix
    isFinishedError: false,
    channel: {
        id: null,
    },
    interlocutor: null,
    equalsScheduled: false,
};

const chatReducer = createSlice({
    name: reducerName,
    initialState,
    reducers: {
        setInterlocutor: (state, action) => ({
            ...state,
            interlocutor: action.payload
        }),
        deleteInterlocutor: (state) => ({
            ...state,
            interlocutor: null
        }),
        setChannel: (state, action) => ({
            ...state,
            channel: action.payload
        }),
        setMessages: (state, action) => ({
            ...state,
            messages: Array.isArray(action.payload) && action.payload.reverse() || action.payload
        }),
        setMessagesCount: (state, action) => ({
            ...state,
            messagesCount: action.payload
        }),
        addNewMessage: (state, action) => ({
            ...state,
            messages: [...state.messages, action.payload],
        }),
        getNewMessageReducer: state => state,
        clearAllMessages: () => initialState,
        setError: (state, action) => ({
            ...state,
            error: true,
        }),
        setFinishedError: (state, action) => ({
            ...state,
            isFinishedError: true,
        }),
        setChatData: (state, action) => ({
            ...state,
            chatData: action.payload
        }),
        setEquals: (state, action) => ({
            ...state,
            equalsScheduled: action.payload
        }),
    }
});

export default chatReducer.reducer;
export const {
    setChannel,
    setMessages,
    setMessagesCount,
    addNewMessage,
    clearAllMessages,
    getNewMessageReducer,
    setError,
    setFinishedError,
    setInterlocutor,
    deleteInterlocutor,
    setChatData,
    setEquals
} = chatReducer.actions;
